<div class="printable">
  <authority-labs-base-certificate-details
    [order]="order"
    [project]="project"
    [subProject]="subProject"
    [company]="company"
    [contact]="contact"
    [assignee]="assignee"
    [approval]="approval"
    [inspection]="inspection"
    [systemDescription]="'מערכת לכיבוי אש באמצעות'"
    [systemSubDescription]="inspection?.fireExtinguishingType"
  ></authority-labs-base-certificate-details>

  <div class="page-break"></div>

  <authority-labs-certificate-planning
    [planner]="planner"
    [inspection]="inspection.inspectionDesign"
  >
    <authority-labs-certificate-end-line
      *ngIf="!isInspectionInstallation"
    ></authority-labs-certificate-end-line>
  </authority-labs-certificate-planning>

  <br *ngIf="isInspectionInstallation" />
  <br *ngIf="isInspectionInstallation" />

  <authority-labs-certificate-installation
    *ngIf="isInspectionInstallation"
    [contractor]="contractor"
    [inspection]="inspection.inspectionInstallation"
    [inspectionDate]="inspection.inspectionDate"
  >
    <authority-labs-certificate-end-line></authority-labs-certificate-end-line>
  </authority-labs-certificate-installation>
</div>
